import React from 'react';
import {
  ReferenceInput,
  ReferenceArrayInput,
  SelectInput,
  AutocompleteArrayInput,
  required,
  useTranslate,
  useLocaleState,
} from 'react-admin';
import { useWatch } from 'react-hook-form';

/**
 * Category Selector Component
 * Handles category and subcategory selection
 */
export const CategorySelector = ({ disabled = false }) => {
  const translate = useTranslate();
  const [locale] = useLocaleState();
  const category = useWatch({ name: 'category' });
  const filter =
    category && String(category).length > 0 ? { category } : { category: 'dummy' };

  const getOptionName = (choice) => {
    if (!choice) return '';
    if (typeof choice.name === 'object' && choice.name !== null) {
      return choice.name[locale] || choice.name.tr || choice.name.en || '';
    }
    return choice.name || '';
  };

  return (
    <React.Fragment>
      <h3>{translate('form.category', 'Category')}</h3>
      <ReferenceInput
        source="category"
        reference="categories"
        sort={{ field: 'name', order: 'ASC' }}
      >
        <SelectInput
          label={translate('form.category', 'Category')}
          emptyText={translate('form.select_category', 'Kategori seçin…')}
          optionText={getOptionName}
          fullWidth
          validate={required()}
          disabled={disabled}
        />
      </ReferenceInput>

      <ReferenceArrayInput
        source="subcategories"
        reference="subcategories"
        label={translate('form.subcategories', 'Sub Categories')}
        filter={filter}
        sort={{ field: 'category', order: 'ASC' }}
      >
        <AutocompleteArrayInput
          fullWidth
          matchSuggestion={() => true}
          filterToQuery={(searchText) => ({ name: searchText })}
          validate={required()}
          optionText={getOptionName}
          label={translate('form.subcategories', 'Sub Categories')}
          placeholder={translate('form.select_subcategory', 'Alt kategori seçin…')}
          disabled={disabled}
        />
      </ReferenceArrayInput>
    </React.Fragment>
  );
};
